export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[550px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20arrangement%20of%20fashion%20lifestyle%20items%20and%20accessories%20on%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20modern%20editorial%20product%20photography%2C%20harmonious%20neutral%20color%20palette%20with%20subtle%20warm%20accents%2C%20clean%20minimal%20aesthetic%20with%20organic%20composition%20and%20generous%20negative%20space&width=1600&height=900&seq=cta-bg-v3&orientation=landscape"
        alt="AllChinaBuy Spreadsheet products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div>
            <h2 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-white leading-tight max-w-xl">
              Start Exploring the Latest AllChinaBuy Spreadsheet
            </h2>
          </div>

          <div className="flex flex-col items-start lg:items-end gap-4">
            <p className="text-white/80 text-base max-w-sm lg:text-right leading-relaxed">
              Browse products, compare sellers, and shop smarter with our verified spreadsheet.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 rounded-lg bg-accent-500 text-foreground-950 font-bold text-sm hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap"
            >
              buy it now
              <span className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}